<template>
  <div>
    <table-list
      class="tableList"
      :loading="loading"
      :data="list"
      :title="tableTitle"
      :columns="columns(this)"
      :btns="btns(this)"
      :pager="pager"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>

<script>
//表格标题
const tableTitle = '证书报名记录'
const btns = _this => [
  {
    label: '返回',
    method: _this.handleReturn,
  },
]

// 表格列配置
const columns = () => [
  {
    prop: 'userName',
    label: '报名人',
    minWidth: '150px',
  },
  {
    prop: 'mobile',
    label: '手机号码',
    minWidth: '150px',
  },
  {
    prop: 'certName',
    label: '证书名称',
    minWidth: '130px',
  },

  {
    prop: 'certLevelShow',
    label: '证书等级',
    minWidth: '150px',
  },
  {
    prop: 'confirmTime',
    label: '确认报名时间',
    minWidth: '150px',
    sortdata: 1,
  },
]

import total from '../../../assets/address/city'
import TableList from '@/components/TableList'
import { getPageInfo } from '@/api/certCenter'
import to from 'await-to'
export default {
  components: {
    TableList,
  },
  data() {
    return {
      tableTitle,
      btns,
      columns,
      loading: false,
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      total,
      list: [],
    }
  },
  created() {
    this.certificateList()
  },
  methods: {
    async certificateList() {
      //parseInt(this.$route.query.appointId) // certPrivateId:certPrivateId
      this.loading = true
      const { current, size } = this.pager
      const [res, err] = await to(
        getPageInfo({
          current,
          size,
          certRelationTrainId: parseInt(this.$route.query.certRelationTrainId),
        }),
      )
      if (err) return this.$message({ type: 'error', message: err.msg })
      this.loading = false
      this.list = res.data.list.map(item => ({
        ...item,
        cityStr: item.provinceName + '-' + item.cityName,
        certLevelShow: item.certLevelShow != null ? item.certLevelShow : '--',
        appointNumber: item.appointNumber != null ? item.appointNumber : '--',
      }))
      this.pager.total = res.data.total
    },
    handleEdit(row) {
      this.$router.push(`/certCenter/add/${row.certId}`)
    },
    handleAppoint(row) {
      this.$router.push(`/certCenter/appoint/${row.certId}`)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.certificateList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.certificateList()
    },
    handleReturn() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="scss"></style>
